import { defineComponent as _defineComponent } from 'vue'
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import RmpIcon from "@rmp/core/components/icon/RmpIcon.vue";
import { RouteNames } from "@rmp/id/router/routes";
import { useMasterAccountAccessStore } from "@rmp/id/stores/masterAccountAccess";
import { storeToRefs } from "pinia";
import { useColors } from "@rmp/core/composables/useColors";

export interface Props {
	title: string;
	preventBackStep?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpMasterAccountAccessApplicationBaseStep',
  props: {
    title: null,
    preventBackStep: { type: Boolean }
  },
  setup(__props: any) {

const useStore = useMasterAccountAccessStore;
const store = useStore();

const { colors } = useColors();

let {
	finalStep
} = storeToRefs(store);



const portalUrl = process.env.VUE_APP_PORTAL_BASE_URL;

return { __sfc: true,useStore, store, colors, finalStep, portalUrl, RmpText, RmpIcon }
}

})